






































































import { Vue, Component } from "vue-property-decorator";
import { required, email } from "vuelidate/lib/validators";
import { namespace } from "vuex-class";
import { Member } from "../types";

const Team = namespace("team");

@Component({})
export default class InviteTeamMember extends Vue {
  @Team.Action("inviteMember") inviteMember!: (payload?: Member) => Promise<{}>;
  @Team.Action("fetchPendingMembers") fetchPendingMembers!: () => Promise<{}>;
  @Team.Action("fetchMembers") fetchMembers!: () => Promise<{}>;
  @Team.Action("fetchSuperAdminCount") fetchSuperAdminCount!: () => Promise<{}>;
  @Team.Getter("getSuperAdminCount") getSuperAdminCount: number;

  loading = false;
  superAdminCount = 0;
  teamForm = {
    firstName: "",
    lastName: "",
    email: "",
    role: 0,
  };
  errorMessage = "";

  async beforeMount() {    
    await this.fetchSuperAdminCount();
  }

  goBack() {
    this.$router.push({ name: "team" });
  }
  setSelectedRole(payload) {
    const { value } = payload;
    this.teamForm.role = value;
  }
  submitTeamInvite() {
    this.loading = true;
    const { firstName, lastName, email, role } = this.teamForm;
    this.inviteMember({
      firstName,
      lastName,
      email,
      role,
    })
      .then(async () => {
        this.fetchMembers();
        this.fetchPendingMembers();

        this.loading = false;
        this.$notify({
          group: "success",
          title: "Success",
          text: "Team member invited successfully.",
        });
        this.goBack();
      })
      .catch((err) => {
        const errorMessage =
          err.response.status === 401
            ? "You do not have the required permissions to carry out this task."
            : "Failed to invite member";
        this.$notify({
          group: "error",
          title: "Error",
          text: errorMessage,
        });
        this.loading = false;
        this.errorMessage = err.message;
      });
  }
  validations() {
    return {
      teamForm: {
        firstName: {
          required,
        },
        lastName: {
          required,
        },
        email: {
          required,
          email,
        },
        role: {
          required,
        },
      },
    };
  }

  get roleOptions() {
    return this.getSuperAdminCount != 0
      ? [
        { name: "Admin", value: 0 },
        { name: "Developer", value: 1 },
        { name: "Reviewer", value: 2 },
      ]
      : [
        { name: "Admin", value: 0 },
        { name: "Developer", value: 1 },
        { name: "Reviewer", value: 2 },
        { name: "Superadmin", value: 3 },
      ];
  }
}
